import type { TerminalTypeDto } from "../../types/TerminalTypeDto";
import type { TerminalTypeEntity } from "../../types/TerminalTypeEntity";

export const TerminalTypeDtoToEntity = ({ ...rest }: Readonly<TerminalTypeDto>): TerminalTypeEntity => {
    return { ...rest };
};
